/**
 * VueI18n
 * --------------------------------------------
 *
 * VueI18n permite la internacionalización de la aplicación en diferentes idiomas.
 * En este caso se usa para el inglés, el catalán y el español.
 *
 */
import en from "./assets/i18n/en.json";
import ca from "./assets/i18n/ca.json";
import es from "./assets/i18n/es.json";
import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

export default new VueI18n({
  locale: sessionStorage.getItem("lang") || navigator.language,
  silentFallbackWarn: true,
  messages: {
    en: en,
    ca: ca,
    es: es,
  },
});
